import buildNudgeAnnotationPayload from '../utils/buildNudgeAnnotationPayload';

export const MOVE_ANNOTATIONS = 'MOVE_ANNOTATIONS';

const positionChanged = (existing, patch) =>
  Object.keys(patch).some((key) => patch[key] !== existing[key]);

const moveAnnotations = (state, payload = {}) => {
  const { updates = [] } = payload;
  if (updates.length === 0) {
    return state;
  }

  let annotations = state.annotations;
  let changed = false;

  updates.forEach((update) => {
    const { id, ...patch } = update;
    const existing = annotations[id];
    if (!existing || existing.locked || Object.keys(patch).length === 0) {
      return;
    }
    if (!positionChanged(existing, patch)) {
      return;
    }
    if (!changed) {
      annotations = { ...state.annotations };
      changed = true;
    }
    annotations[id] = {
      ...existing,
      ...patch,
    };
  });

  if (!changed) {
    return state;
  }

  return {
    ...state,
    isDesignState: payload.isDesignState ?? true,
    annotations,
  };
};

export const buildMoveUpdateFromNode = (annotation, node) => {
  if (!annotation?.id || !node) {
    return null;
  }

  if (Array.isArray(annotation.points) && annotation.points.length >= 2) {
    const rect = node.getClientRect({ relativeTo: node.getParent() });
    const deltaX = node.x() - annotation.x;
    const deltaY = node.y() - annotation.y;
    if (deltaX === 0 && deltaY === 0) {
      return null;
    }
    return buildNudgeAnnotationPayload(annotation, deltaX, deltaY);
  }

  const nextX = node.x();
  const nextY = node.y();
  if (nextX === annotation.x && nextY === annotation.y) {
    return null;
  }

  return {
    id: annotation.id,
    x: nextX,
    y: nextY,
  };
};

export default moveAnnotations;
